import { render, staticRenderFns } from "./ListNews.vue?vue&type=template&id=6d9faf0a&scoped=true"
import script from "./ListNews.vue?vue&type=script&lang=js"
export * from "./ListNews.vue?vue&type=script&lang=js"
import style0 from "./ListNews.vue?vue&type=style&index=0&id=6d9faf0a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9faf0a",
  null
  
)

export default component.exports